import { DotLegalDialog, DotLegalHeader, DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "../../localization/useTranslation";
import { Box } from "@mui/material";
import useTransferContractAccessBusinessAreaDialogHooks from "./TransferContractAccessBusinessAreaDialog.hooks";

export interface ITransferContractAccessBusinessAreaDialog {
    onDialogClose: () => void;
}

function TransferContractAccessBusinessAreaDialog(props: ITransferContractAccessBusinessAreaDialog) {
    const { translateString } = useTranslation();
    const { fromBusinessAreas, toBusinessAreas, transferModel, onFromBusinessAreaChange, onToBusinessAreaChange, transfer, transferButtonEnabled, inProgress } =
        useTransferContractAccessBusinessAreaDialogHooks(props);

    return (
        <DotLegalDialog
            okButtonDisabled={!transferButtonEnabled}
            size="sm"
            header={translateString("transferContractAccessBusinessArea")}
            buttonOkText={translateString("move")}
            open
            onDialogClose={() => props.onDialogClose()}
            onOkClick={() => transfer()}
            inProgress={inProgress}
            disableBackdropOnCloseIfValueChange={transferModel}
        >
            <Box sx={{ marginLeft: 2, marginRight: 2 }}>
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <DotLegalHeader center fontWeight={0} headerStyle={"small"}>
                        {translateString("transferContractAccessBusinessAreaInfo")}
                    </DotLegalHeader>
                </Box>
                <Box sx={{ display: "flex", justifyContent: "center", flexDirection: "column", gap: 1 }}>
                    <DotLegalSelect
                        options={fromBusinessAreas}
                        onChange={(businessAreaId) => onFromBusinessAreaChange(businessAreaId)}
                        placeholder={translateString("from")}
                        label={translateString("from")}
                        noOptionsLabel={""}
                        selectedItem={transferModel.fromBusinessAreaId}
                    />
                    <DotLegalSelect
                        options={toBusinessAreas}
                        onChange={(businessAreaId) => onToBusinessAreaChange(businessAreaId)}
                        placeholder={translateString("to")}
                        label={translateString("to")}
                        noOptionsLabel={""}
                        selectedItem={transferModel.toBusinessAreaId}
                    />
                </Box>
            </Box>
        </DotLegalDialog>
    );
}

export default TransferContractAccessBusinessAreaDialog;
